<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/ic/baseline-edit";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.InputIcon v-tooltip.left="'Ubah'">
        <Icon class="text-gray-500 hover:text-gray-700 hover:cursor-pointer" @click="$emit('click')" />
    </PV.InputIcon>
</template>
